import React, { useEffect } from "react";
import Box from "@mui/material/Box";
import LoadingButton from "@mui/lab/LoadingButton";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import Alert from "@mui/material/Alert";
import * as colors from "@mui/material/colors";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { Controller, useForm } from "react-hook-form";
import { signUpStart, clearSignUp } from "../../store/auth/reducer";

const DEFAULT_VALUES = {
  firstName: "",
  lastName: "",
  phoneNumber: "",
  email: "",
  password: "",
  confPassword: "",
};

export const SignUp = ({ setActive , setEmail}) => {
  const dispatch = useDispatch();
  const { signUpLoading, signUpSuccess, signUpError } = useSelector(
    (state) => state.auth
  );
  const {
    control,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: DEFAULT_VALUES,
  });

  useEffect(() => {
    if (signUpSuccess) {
   
      reset(DEFAULT_VALUES);
      toast.info("Registered successfully", {
        position: "bottom-right",
        autoClose: 3000,
        hideProgressBar: true,
        closeOnClick: true,
        closeButton: false,
      });
      dispatch(clearSignUp());
      setActive();
    }
  }, [signUpSuccess]);

  const onSubmit = (values) =>
  
    dispatch(
 
      signUpStart({
        ...values,
        confPassword: values.password,
      }),
      setEmail(values.email)

    );
  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: "20px",
          marginTop: "20px",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: "10px",
          }}
        >
          <Typography variant="h4">Sign Up</Typography>
          <Typography variant="caption" sx={{ color: colors.grey[500] }}>
            Please provide details to create your account
          </Typography>
        </Box>
        {signUpError && <Alert severity="error">{signUpError}</Alert>}
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            gap: "20px",
          }}
        >
          <Controller
            name="firstName"
            control={control}
            rules={{
              required: {
                value: true,
                message: "First name is requried",
              },
              pattern: {
                value: /^[a-z ,.'-]+$/i,
                message: "Please enter valid first name",
              },
            }}
            render={({ field }) => (
              <TextField
                {...field}
                label=" First Name"
                variant="standard"
                sx={{
                  width: "100%",
                }}
                helperText={errors.firstName && errors.firstName.message}
                error={!!errors.firstName}
              />
            )}
          />

          <Controller
            name="lastName"
            control={control}
            rules={{
              required: {
                value: true,
                message: "Last name is requried",
              },
              pattern: {
                value: /^[a-z ,.'-]+$/i,
                message: "Please enter valid last name",
              },
            }}
            render={({ field }) => (
              <TextField
                {...field}
                label="Last Name"
                variant="standard"
                sx={{
                  width: "100%",
                }}
                helperText={errors.lastName && errors.lastName.message}
                error={!!errors.lastName}
              />
            )}
          />
        </Box>

        <Controller
          name="email"
          control={control}
          rules={{
            required: {
              value: true,
              message: "Email address is requried",
            },
            pattern: {
              value: /^\S+@\S+\.\S+$/,
              message: "Please enter valid emial address",
            },
          }}
          render={({ field }) => (
            <TextField
              {...field}
              label="Email Address"
              variant="standard"
              sx={{
                width: "100%",
              }}
              helperText={errors.email && errors.email.message}
              error={!!errors.email}
            />
          )}
        />

        <Controller
          name="phoneNumber"
          control={control}
          rules={{
            required: {
              value: true,
              message: "Phone number is requried",
            },
            pattern: {
              value: /^\+?[1-9][0-9]{7,14}$/,
              message: "Please enter valid phone number (e.g +251911121314)",
            },
          }}
          render={({ field }) => (
            <TextField
              {...field}
              label="Phone Number"
              variant="standard"
              sx={{
                width: "100%",
              }}
              helperText={errors.phoneNumber && errors.phoneNumber.message}
              error={!!errors.phoneNumber}
            />
          )}
        />

        <Controller
          name="password"
          control={control}
          rules={{
            required: {
              value: true,
              message: "Password is requried",
            },
            pattern: {
              value:
                /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$/,
              message:
                "Please enter strong password (at least 8 characters, must have upperase, lowercase, number and special character)",
            },
          }}
          render={({ field }) => (
            <TextField
              {...field}
              label="Password"
              variant="standard"
              type="password"
              sx={{
                width: "100%",
              }}
              helperText={errors.password && errors.password.message}
              error={!!errors.password}
            />
          )}
        />

        <LoadingButton
          color="primary"
          sx={{
            backgroundColor: colors.blue[800],
            color: "#FFFFFF",
            "&:hover": {
              backgroundColor: colors.blue[800],
            },
            marginTop: "10px",
          }}
          loading={signUpLoading}
          type="submit"
        >
          Submit
        </LoadingButton>
        <Box
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "center",
            gap: "3px",
          }}
        >
          <Typography variant="caption">Already have an account?</Typography>
    
          <div onClick={setActive}>
            <Typography
              variant="caption"
              sx={{
                color: colors.blue[600],
                cursor: "pointer",
              }}
            >
              Login
            </Typography>
          </div>
        </Box>
      </Box>
    </form>
  );
};
